import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navigation() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    label: 'O que Inclui',
    href: '#incluye'
  }, {
    label: 'Benefícios',
    href: '#beneficios'
  }, {
    label: 'Depoimentos',
    href: '#testimonios'
  }, {
    label: 'Comprar',
    href: '#comprar'
  }];
  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
  };
  return <>
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm" data-id="element-73">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-74">
          <div className="flex items-center justify-between h-12 md:h-14" data-id="element-75">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.2
          }} className="flex items-center gap-2" data-id="element-76">
              <span className="text-xl md:text-2xl" data-id="element-77">🎨</span>
              <span className="text-sm sm:text-base md:text-lg font-bold text-red-700" data-id="element-78">
                Mega Pacote Artes
              </span>
            </motion.div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8" data-id="element-79">
              {navLinks.map((link, index) => <motion.a key={link.href} href={link.href} initial={{
              opacity: 0,
              y: -20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.1 * index
            }} className="text-gray-700 hover:text-red-700 font-medium transition-colors duration-200 text-sm" data-id="element-80">
                  {link.label}
                </motion.a>)}
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2 rounded-md text-gray-700 hover:text-red-700 hover:bg-gray-100 transition-colors" aria-label="Toggle menu" data-id="element-81">
              {isMobileMenuOpen ? <XIcon className="h-5 w-5" data-id="element-82" /> : <MenuIcon className="h-5 w-5" data-id="element-83" />}
            </button>
          </div>
        </div>
      </motion.nav>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-84">
        {isMobileMenuOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setIsMobileMenuOpen(false)} className="fixed inset-0 bg-black/50 z-40 md:hidden" data-id="element-85" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'tween',
          duration: 0.3
        }} className="fixed top-12 right-0 bottom-0 w-64 bg-white shadow-2xl z-50 md:hidden" data-id="element-86">
              <div className="flex flex-col p-6 space-y-4" data-id="element-87">
                {navLinks.map((link, index) => <motion.a key={link.href} href={link.href} onClick={handleLinkClick} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: index * 0.1
            }} className="text-lg font-medium text-gray-700 hover:text-red-700 py-3 border-b border-gray-200 transition-colors" data-id="element-88">
                    {link.label}
                  </motion.a>)}
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}